module.exports = __webpack_public_path__ + "static/media/california_caviar_tuna.829095aa.webp";